import { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { INavButton } from '../../Button.types';

const NavButton: FC<INavButton> = ({ text, to, classes, 'data-id': dataId }) => {
  return (
    <NavLink to={to} className={classes?.container} data-id={dataId}>
      <span className={classes?.text}>{text}</span>
    </NavLink>
  );
};

export default NavButton;
